import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';

import { FundChartDateZoomComponent } from './components/fund-chart-date-zoom/fund-chart-date-zoom.component';
import { FundChartLegendComponent } from './components/fund-chart-legend/fund-chart-legend.component';
import { FundamentalChartComponent } from './components/fundamental-chart/fundamental-chart.component';

@NgModule({
    declarations: [FundamentalChartComponent, FundChartDateZoomComponent, FundChartLegendComponent],
    imports: [ChartsSharedModule, CommonModule, DisabledModule, FeatureNeededModule, IconModule, TooltipModule],
    exports: [FundamentalChartComponent, FundChartLegendComponent, FundChartDateZoomComponent],
})
export class FundamentalChartModule {}
